import { PlayGroundAction } from "../../../../shared/constants/previewBalance.constants";

export class ChangesItem {
    reportId: number;
    action: PlayGroundAction;
    facilityCode: string;
    roomNumber: string;
    staffId: number;
    staffName: string;
    changeInfo: string;
    newLimitToRack: string;
    previousLimitToRack: string;
    playgroundChangeId: number;
    constructor() { }
}

export class StaffPlaygroundActionVM {
    reportId: number;
    action: PlayGroundAction;
    facilityCode: string;
    roomNumber: string;
    staffId: number;
    staffName?: string;
    selectedRackIdsArray: number[];
    playgroundChangeId: number;
    newLimitToRack: string;
    previousLimitToRack: string;
    constructor() { }
}

export class RoomStaffByRack {
    staffId: number;
    staffName?: string;
    ccrackId: number;
    assignmentPriority: number;
    scheduleDates: string[];
    constructor() { }
}